// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "app-single-review {\n  width: 100%;\n}\n\n.average-rating-star {\n  margin-right: 4px;\n  font-size: 20px;\n}\n\n.more-reviews {\n  color: #3246F0 !important;\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
